export function buildSamlLoginUrl(returnTo = '/') {
  const url = new URL('/saml/login', window.location.origin);
  url.searchParams.set('return_to', returnTo);
  return url.toString();
}
